import { IMacListItem } from '@models/MacListItem';
import { MacExportFormat } from '@apiHooks/useMacExport';

export const MAC_EXPORT_OPTIONS: ReadonlyArray<{ label: string; format: MacExportFormat }> = [
    { label: 'PPT', format: 'pptx' },
    { label: 'PNG', format: 'png' },
];

export const MACS_DEFAULT_FIELDS_SORTING: Partial<Record<keyof IMacListItem, 'asc' | 'desc'>> = {
    title: 'asc',
    description: 'asc',
    itemsCount: 'desc',
    dateSort: 'desc',
};

export const MACS_SEARCH_PLACEHOLDER = 'Search for a specific MAC';
